import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { AppService } from '../shared/services/app.service';

@Injectable({ providedIn: 'root' })
export class LoginGuard  {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private appService: AppService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            this.router.navigate([this.appService._appData.DEFAULT_APPLICATION+'/dashboard']);
            return false;
        }
        this.authenticationService.logout(()=>{           
            
        });
        return true;
        
    }  
}